import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n) => `$${Number(n).toFixed(2)}`;

export const resolveImg = (src) => {
  if (!src) return "";
  return src.startsWith("http") ? src : `${process.env.REACT_APP_BACKEND_URL}${src}`;
};

export const track = (event_type, source, metadata) => {
  api.post("/track", { event_type, source, metadata }).catch(() => {});
};
